import { UnitDistance } from './Interfaces';

const storeDetails = `
    id
    store_url
    showStoreDetails
    address {
        city
        country
        country_code
        county
        description
        neighbourhood
        postal_code
        state
    }
    name
    opening {
        open_hours {
            open
            close
        }
        label
        day_of_week
        __typename
    }
    geographical {
        coordinates ... on GeographicalFilter { distance unit }
    }
    tags {
        items { label type }
    }
    phone_number { position label value }
    counter_id
    jdaStoreNumber
    promotions
    in_store_pickup
    opening_attributes {
        isOpen
        time
    }
    holidays {
        name
        date
        dayOfWeek
        openingTime
        closingTime
        hoursMessage
    }
`;

export const storeServices = `
    services {
        name
        price
        totalDuration
        totalDurationWithPadding
        id
        onlineContentId
        virtual
        category{
            id
            name
            parentId
        }
    }
`;

export const events = `
    upcomingEventsNumber
    events {
        eventName
        eventDate
        eventTime
        eventType
        eventRsvpPhone
        presenter1
        presenter2
        presenterImage
        description
        price
        startDate
        endDate
        upcomingEvent
    }
`;

export const queryBuilder = {
    getStoresByGeo: (showEvents: boolean | undefined) => ` on StoreCollection
        { 
            total
            items {
                ${storeDetails}
                ${
                    showEvents
                        ? `
                upcomingEventsNumber
                events {
                    upcomingEvent
                }
                `
                        : ''
                }
                opening_attributes {
                   isOpen
                   changes
                   time
                }
            }
        }`,
    getStoreById: ` on Store
        {
            ${storeDetails}
        }`,
    getStoresByIds: ` on StoreCollection
        {
            total
            items {
                ${storeDetails}
            }
        }`,
    getStoresDirectory: ` on StoreCollection
        {            
            showState
            total
            items {
                name
                id
                address {
                    city
                    country
                    country_code
                    county
                    description
                    neighbourhood
                    postal_code
                    state
                }
                store_url
            }       
        }
    `
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const queryfy = (obj: any): string | number => {
    if (typeof obj === 'number' || obj in UnitDistance) {
        return obj;
    }

    if (Array.isArray(obj)) {
        const props = obj.map((value) => `${queryfy(value)}`).join(',');

        return `[${props}]`;
    }

    if (typeof obj === 'object') {
        const props = Object.keys(obj)
            .map((key) => `${key}:${queryfy(obj[key])}`)
            .join(',');

        return `{${props}}`;
    }

    return JSON.stringify(obj);
};
